import { Text, Tooltip } from '@customerio/pluma-components/react';
import { formatDateTime } from '@customerio/pluma-components/react/utils/formatted-date-time';
import type { Delivery } from '@/services/db/delivery/entity';
import { formatShortCalendar } from '../../utils/short-calendar';

type DateCellProps = { delivery: Delivery };

/**
 * "Date Created" cell — the delivery's created timestamp in Ember's
 * `ShortDate`/`shortCalendar` format (calendar-relative for the surrounding
 * week, "MMM D, YYYY" with no time for older rows), with the full timestamp in
 * a hover tooltip.
 */
export function DateCell({ delivery }: DateCellProps) {
  if (delivery.created == null) {
    return (
      <Text size="xxs" color="subtle">
        —
      </Text>
    );
  }
  return (
    <Tooltip content={formatDateTime(delivery.created * 1000, 'full_with_time')}>
      <Text size="xxs" color="subtle">
        {formatShortCalendar(delivery.created)}
      </Text>
    </Tooltip>
  );
}
